import {Component, OnDestroy, OnInit, HostListener} from '@angular/core';
import {BaseMeasure} from '../base_measure.component';
import {MatDialog, MatSnackBar} from '@angular/material';
import {MeasurementHelperService} from '../../../../../service/measurement-helper.service';
import {EntityHelperService} from '../../../../../service/entity-helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MapComponent} from '../../../map.component';
import {MapService} from '../../../../../commons/map.service';
import { XsApplicationEventsService } from '../../../../../xs/services/events/application-events.service';
import { EpsgHelperService } from '../../../../../service/epsg-helper.service';
import { FileManagementService } from '@src/app/service/file-manager.service';

@Component({
  selector: 'app-multi-poi',
  templateUrl: './../line.component.html',
  styleUrls: ['./multi-poi.component.scss','../../../map_commons.scss']
})
export class MultiPoiComponent extends BaseMeasure implements OnInit, OnDestroy {

  constructor(protected route: ActivatedRoute, public router: Router, snackBar:
    MatSnackBar, dialog: MatDialog, public mapComp: MapComponent, public mapService: MapService, public mappingHelper: MeasurementHelperService, 
    public entityHelper: EntityHelperService, public applicationEvents:XsApplicationEventsService, public epsgHelper: EpsgHelperService, public fileManager: FileManagementService ) {
    super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager );

  }

  ngOnInit() {
    // because of local coordinates the sequence of loading scene is changed so once scene is ready we process
    if(this.mapService.scene){
      super.onInit();
    }else {
      this.addSubscription( 'multiPoi-sceneChange',
        this.mapService.onSceneChange('multi-poi.component').subscribe(_ => {
          super.onInit();
        })
      );
    }
  }

  @HostListener('unloaded')
  ngOnDestroy() {
    super.onDestroy();
  }

}
